








import { Component, Vue } from "vue-property-decorator";
import Fleteros from "@/components/Web/Fleteros.vue";

@Component({
  components: {
    Fleteros
  },
  meta: {
    // sets document title
    title: "Fletes - Ilustre Municipalidad de Punta Arenas",
    // optional; sets final title as "Index Page - My Website", useful for multiple level meta
    //titleTemplate: title => `${title} - My Website`,

    // meta tags
    meta: {
      description: {
        name: "description",
        content: "Revisa aquí los datos de fletes disponibles para ti."
      },
      keywords: { name: "keywords", content: "Punta Arenas" },
      equiv: {
        "http-equiv": "Content-Type",
        content: "text/html; charset=UTF-8"
      }
    }
  }
})
export default class FletesView extends Vue {
  private mounted() {
    document.title = "Fletes - Ilustre Municipalidad de Punta Arenas";
  }
}
